import axios from './axios-wrapper';
import { batchBySize } from './requestSizing';

function getAllShifts(from, to, params) {
  return axios.get(`shifts/${from}/${to}`, { params });
}

function getFillingShifts() {
  return axios.get('shifts/filling');
}

function getFillingShiftsBetween(from, to) {
  return axios.get(`shifts/filling?from=${from}&to=${to}`);
}

function getShift(id) {
  return axios.get(`shift/${id}`);
}

// Only send the fields the API persists - callers (e.g. ShiftAdd.vue) may
// carry extra UI-only fields (names, draft ids...) that just bloat the
// request body without this trim.
function toShiftPayload(shift) {
  return {
    client_id: shift.client_id,
    location_id: shift.location_id,
    date: shift.date,
    start_time: shift.start_time,
    end_time: shift.end_time,
    type: shift.type,
    booking_method: shift.booking_method,
    booking_by: shift.booking_by,
    work_order_reference: shift.work_order_reference,
  };
}

async function createShifts(shifts, { onBatchSaved } = {}) {
  // Batch the *original* shift objects (not the trimmed payload) so that on
  // success we can hand each saved batch back to the caller - e.g. so a
  // draft list UI can remove exactly the shifts that made it to the DB.
  // Batches are sized by actual serialized byte size rather than a fixed
  // item count, since shift objects vary a lot in size (long location/
  // client names etc. push a "10 shifts" batch over the limit just as
  // easily as a "30 shifts" batch of short ones).
  const batches = batchBySize(shifts, toShiftPayload, {
    wrap: (payload) => ({ shifts: payload }),
  });
  let saved = 0;

  for (const batch of batches) {
    const payload = batch.map(toShiftPayload);
    try {
      // eslint-disable-next-line no-await-in-loop
      await axios.post('shift/create', { shifts: payload });
      saved += batch.length;
      if (onBatchSaved) {
        onBatchSaved(batch);
      }
    } catch (err) {
      err.saved = saved;
      err.total = shifts.length;
      throw err;
    }
  }

  return { saved, total: shifts.length };
}

function importShifts(input) {
  return axios.post('shift/import', { shifts: input });
}

function deleteShift(id) {
  return axios.delete(`shift/delete/${id}`);
}

function editShift(id, shift) {
  return axios.put(`shift/edit/${id}`, { shift });
}

function cancelShift(id, cancellation) {
  return axios.post(`shift/cancel/${id}`, { cancellation });
}
function getCancellations(from, to) {
  return axios.get(`shift/cancellations/${from}/${to}`);
}

function getShiftCancellations(shift_id) {
  return axios.get(`shift/cancellations/${shift_id}`);
}

function undoCancellation(shift_id) {
  return axios.delete(`shift/cancellations/${shift_id}`);
}

function deleteOffer(shift_id, employee_id) {
  return axios.delete(
    `/shift/offers?shift_id=${shift_id}&employee_id=${employee_id}`
  );
}

export default {
  getAllShifts,
  getShift,
  createShifts,
  importShifts,
  deleteShift,
  editShift,
  getFillingShifts,
  getFillingShiftsBetween,
  cancelShift,
  getCancellations,
  undoCancellation,
  deleteOffer,
  getShiftCancellations,
};
